/**
 * One header for every top-level screen.
 *
 * Each of them had grown its own, built from another screen's class names — the voices panel wore
 * `relevance__head`, the flow diagram wore `broadcasts__tools` — along with a hand-placed link back
 * to the index and its own copy of the theme toggle. The rail carries navigation now, so a header
 * is only ever a title, the sentence that says what the screen is for, and the actions that belong
 * to this screen and no other.
 */
export function PageHeader({ title, children, actions }: { title: string; children?: React.ReactNode; actions?: React.ReactNode }) {
  return (
    <header className="page-head landmark">
      <div className="page-head__text">
        <h1 className="page-head__title">{title}</h1>
        {children && <p className="page-head__note">{children}</p>}
      </div>
      {actions && <div className="page-head__actions">{actions}</div>}
    </header>
  );
}
